import { render, staticRenderFns } from "./page-view.vue?vue&type=template&id=00b688f9&"
import script from "./page-view.vue?vue&type=script&lang=ts&"
export * from "./page-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b688f9')) {
      api.createRecord('00b688f9', component.options)
    } else {
      api.reload('00b688f9', component.options)
    }
    module.hot.accept("./page-view.vue?vue&type=template&id=00b688f9&", function () {
      api.rerender('00b688f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page-view.vue"
export default component.exports